
import { PlanInfoConfigurableStep } from '../../components';
import { getEligibility } from '../machine/utils';
import { StudentOnboardingMachineContext } from '../types';

type BookingFirstInterstitialPageProps = {
  context: StudentOnboardingMachineContext;
  onNext: () => void;
  onBack: () => void;
};

export const BookingFirstInterstitialPage: React.VFC<BookingFirstInterstitialPageProps> = ({
  context,
  onNext,
  onBack
}) => {
  const {
    psychFirst,
    freeTherapySessions,
    firstSixFreeTherapySessions,
    freePsychiatrySessions,
    freePsychiatryConsultation,
  } = getEligibility(context);

  let res = null;

  switch (true) {
    // Free therapy sessions with Sponsorship & Insurance
    case freeTherapySessions:
      res = (
        <PlanInfoConfigurableStep
          onNext={onNext}
          onBack={onBack}
          headerTitle="You qualify for"
          headerHighlight="free therapy sessions"
          contentTitle="Your school offers free therapy sessions through UpLift."
          contentDescription="Through our partnership with your school, your session costs are fully covered as long as you provide your insurance information."
        />
      );
      break;

    // First 6 free therapy sessions with Sponsorship & No Insurance
    case firstSixFreeTherapySessions:
      res = (
        <PlanInfoConfigurableStep
          onBack={onBack}
          onNext={onNext}
          headerTitle="Your first"
          headerHighlight="6 therapy sessions are free"
          contentTitle="To increase your number of free sessions add insurance."
          contentDescription="Your first six sessions are fully paid for through your school's partnership with UpLift."
          nextButtonText="Continue without insurance"
          secondaryButtonText="Add insurance"
          onSecondaryClick={onBack}
        />
      );
      break;

    // Free psychiatry sessions with Sponsorship & Insurance
    case freePsychiatrySessions && psychFirst:
      res = (
        <PlanInfoConfigurableStep
          onNext={onNext}
          onBack={onBack}
          headerTitle="You qualify for"
          headerHighlight="free psychiatry sessions"
          contentTitle="Your school offers free psychiatry sessions through UpLift."
          contentDescription="Through our partnership with your school, your session costs are fully covered as long as you provide your insurance information."
        />
      );
      break;

    // Free psychiatry consultation with Sponsorship & No Insurance
    case freePsychiatryConsultation && psychFirst:
      res = (
        <PlanInfoConfigurableStep
          onBack={onBack}
          onNext={onNext}
          onSecondaryClick={onBack}
          headerTitle="Your first"
          headerHighlight="psychiatry consultation is free"
          contentTitle="To increase your number of free sessions add insurance."
          contentDescription="Your consultation is fully paid for through your school's partnership with UpLift."
          secondaryButtonText="Add Insurance"
        />
      );
      break;
  }

  if (!res) {
    console.log('No matching condition found for BookingFirstInterstitialPage', getEligibility(context));
    onNext();
  }

  return res;
};
